import { useState } from "react";
import { Button } from "@/Components/ui/button";
import {
   Dialog,
   DialogContent,
   DialogHeader,
   DialogTitle,
   DialogTrigger,
} from "@/Components/ui/dialog";
import { useAdminStore } from "@/store/useAdminStore";
import LearnMoreContent from "./LearnMoreContent";
import { useTranslation } from "@/hooks/use-translation";

interface LearnMoreProps {
   learnMoreId: number;
}

export function LearnMore({ learnMoreId }: LearnMoreProps) {
   const [isOpen, setIsOpen] = useState(false);
   const { allLearnMore } = useAdminStore();
   const { translation } = useTranslation();
   const learnMore = allLearnMore?.find(
      (lm: { id: number; content: string }) => lm.id === learnMoreId
   );

   if (!learnMore) return null;

   return (
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
         <DialogTrigger asChild>
            <Button
               variant="ghost"
               size="lg"
               className="w-full justify-end p-0 underline uppercase hover:bg-transparent hover:text-gray-500 "
            >
               {translation.learnMore}
            </Button>
         </DialogTrigger>
         <DialogContent className="max-w-2xl">
            <DialogHeader>
               <DialogTitle className="text-2xl font-semibold">
                  {translation.learnMore}
               </DialogTitle>
            </DialogHeader>
            <div className="mt-4">
               <LearnMoreContent learnMore={learnMore} />
            </div>
         </DialogContent>
      </Dialog>
   );
}
